import React from "react";
import useConfig from "../../hooks/useConfig";

const Advisors = props => {

    let settings = useConfig(props.company);

    React.useEffect(() => {
        document.title = "Live Show - Meet with an Advisor";
        if (!settings) return;
        let script = document.createElement("script");
        script.src = settings.tagUrl;
        script.async = true;
        document.head.appendChild(script);
    }, [settings]);

    if (!settings) return null;

    return (
        <div className="App">
            <img src={settings.logo} alt="" />
        </div>
    )
}

export default Advisors;